import { render, staticRenderFns } from "./BasicLinks.vue?vue&type=template&id=c0f41dfa&scoped=true"
import script from "./BasicLinks.vue?vue&type=script&lang=js"
export * from "./BasicLinks.vue?vue&type=script&lang=js"
import style0 from "./BasicLinks.vue?vue&type=style&index=0&id=c0f41dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f41dfa",
  null
  
)

export default component.exports